import Vue from 'vue'

const MAX_FAVORITES = 6

export default {
  namespaced: true,
  state: {
    favorites: {},
    categories: {
      "prod":["Clientes y Ventas","Servicio","Compras y Finanzas","Recursos Corporativos","Submitals","Catálogos"]
    }
  },
  getters: {
    maxFavorites: () => MAX_FAVORITES,
    favoriteIds: (state) => (scope) => state.favorites[scope] || [],
    selectedCategories: (state) => (scope) => state.categories[scope] || []
  },
  mutations: {
    toggleFavorite (state, { scope, id }) {
      const list = state.favorites[scope] || []
      let next = list
      if (list.includes(id)) {
        next = list.filter(x => x !== id)
      } else if (list.length < MAX_FAVORITES) {
        next = [...list, id]
      }
      Vue.set(state.favorites, scope, next)
    },
    setCategories (state, { scope, names }) {
      Vue.set(state.categories, scope, names)
    }
  }
}